export function isFullscreen() {
  if (typeof document === 'undefined') return false;
  return Boolean(document.fullscreenElement || document.webkitFullscreenElement);
}

export async function enterFullscreen(element) {
  const el = element || (typeof document !== 'undefined' ? document.documentElement : null);
  if (!el) throw new Error('Fullscreen API unavailable');
  if (el.requestFullscreen) return el.requestFullscreen();
  if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
  throw new Error('Fullscreen API unavailable');
}

export async function exitFullscreen() {
  if (typeof document === 'undefined') return;
  if (document.exitFullscreen) return document.exitFullscreen();
  if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
}

export function subscribeFullscreenChange(handler) {
  if (typeof document === 'undefined') return () => {};
  document.addEventListener('fullscreenchange', handler);
  document.addEventListener('webkitfullscreenchange', handler);
  return () => {
    document.removeEventListener('fullscreenchange', handler);
    document.removeEventListener('webkitfullscreenchange', handler);
  };
}
